import React from 'react';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getLength } from 'common/utilities/utils';
import { UpsizeSeelectAnalytics } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';

const PdpSummaryUpsizeComponent = ({ upsizeInfo, upSizeHandler, itemSelected, customizable }) => {
  const upSize = (id, desc) => {
    upSizeHandler(id);
    const modifiersObj = {
      name: desc?.itemDesc,
      size: desc?.itemDesc?.split(' ')[0],
    };
    UpsizeSeelectAnalytics(modifiersObj, MENU_PDP_PAGE_CONSTANTS.ADDONS);
  };
  const getDescContainer = desc => {
    return customizable ? (
      <span className='size-desc'>{desc.itemDesc}</span>
    ) : (
      <span>
        <span className='size-desc size-desc-price'>{desc.price}</span>
        {desc.calories && <span className='size-desc size-desc-cal'>{desc.calories}</span>}
      </span>
    );
  };
  let upsizeViewTemplate = (id, title, desc, index) => {
    return (
      <div className='modifier-size' key={index}>
        <div className='size-info'>
          <span className='size-title'>{title}</span>
          {getDescContainer(desc)}
        </div>
        <picture onClick={() => id !== itemSelected && upSize(id, desc)} data-testid={`upsize-handler-id-${index}`}>
          <source
            media='(max-width: 1023px)'
            srcSet={id === itemSelected ? IMAGE_PATH.Check_Icon : IMAGE_PATH.Selection_Checkbox_off}
            alt={id === itemSelected ? 'checked' : ''}
          />
          <img
            src={id === itemSelected ? IMAGE_PATH.Check_Icon : IMAGE_PATH.Selection_Checkbox_off}
            alt={id === itemSelected ? 'checked' : ''}
          />
        </picture>
      </div>
    );
  };
  return (
    <div className='sopac-upsize'>
      {getLength(upsizeInfo) &&
        upsizeInfo.map(({ id, title, desc }, index) => {
          return upsizeViewTemplate(id, title, desc, index);
        })}
    </div>
  );
};

export default React.memo(PdpSummaryUpsizeComponent);
